"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _createChainablePropType = _interopRequireDefault(require("./createChainablePropType"));

var _UnsafeUrl = require("../UnsafeUrl");

function validHrefValidator(props, propName, componentName) {
  if (props[propName]) {
    var value = props[propName];

    if (typeof value !== 'string' || value === '#') {
      return new Error(componentName + ": Invalid href \"" + value + "\". If provided, the href " + 'prop must be a valid URL.');
    }

    if ((0, _UnsafeUrl.isUnsafeUrl)(value)) {
      return new Error(componentName + ": href \"" + value + "\" could be an XSS attack and will be ignored. " + 'See https://git.hubteam.com/HubSpot/UIComponents/issues/2599');
    }
  }

  return null;
}

var validHref = (0, _createChainablePropType.default)(validHrefValidator, 'validHref');
var _default = validHref;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3722/js/utils/propTypes/validHref.js
// module id = 228
// module chunks = 5 6 7